// import DOMPurify from "dompurify";
import parse from "html-react-parser";

import DOMPurify from 'isomorphic-dompurify';

const sanitizeHTML = (html) => {

    const safeHTML = DOMPurify.sanitize(html, {

        ALLOWED_TAGS: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'strong', 'br', 'i', 'p', 'sup', 'li', 'ul', 'span', 'a', 'div', 'b', 'figure', 'img'],
        ALLOWED_ATTR: ["style", "href", "title", "class", "src", "alt"],
      
      });
      
    
    return (
        parse(safeHTML)
    );
}

export default sanitizeHTML;